<template>
  <div :style="`width:${size}px`">
    <BaseCard :height="size" :width="size" color="grey" class="relative">
      <BaseImage :src="src" :cover="true" :aspect-ratio="1"></BaseImage>
      <BaseButton
        :absolute="true"
        :fab="true"
        :height="24"
        :width="24"
        color="black"
        @click="$emit('delete')"
        style="top:8px; right:8px"
      >
        <BaseIcon color="white" size="16">close</BaseIcon>
      </BaseButton>
      <BaseSheet
        v-if="loading"
        color="white"
        style="position: absolute; bottom: 8px; right:8px"
        class="rounded-circle d-flex justify-center align-center"
        height="24px"
        width="24px"
      >
        <BaseCircularProgress
          :indeterminate="true"
          color="secondary"
          :width="3"
          :size="16"
        ></BaseCircularProgress>
      </BaseSheet>
    </BaseCard>
    <slot name="input"></slot>
  </div>
</template>

<script>
export default {
  name: "BasePictureThumbnail",
  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: Number,
      default: 144
    },
    src: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
